import Card from 'components/card/card';

export default Card;
